module.exports = __webpack_public_path__ + "img/banner_title_tc.4c30c7e6.gif";